import React from 'react'
import { Select, SelectProps } from "@mui/material";

// interface selectProps extends SelectProps { }

const CustomSelectTwo = (props) => {
    const { children, ...rest } = props;
    return (
        <Select
            value={props.status}
            onChange={props.searchChange1}
            MenuProps={{
                hidden: false,
                PaperProps: {
                    sx: {
                        boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                        borderRadius: "8px",
                        marginTop: "5px",
                        minWidth:"auto",
                        color:"rgb(55, 65, 81)",

                        "& .MuiMenuItem-root": {
                            padding: "8px 10px 8px 18px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#373737",
                            lineHeight: "1",
                            display: 'block',

                            "&:hover": {
                                background: "#F4F4F4",
                                borderRadius: "4px",

                            },

                            "&:not(:last-child)": {
                                marginBottom: "4px"
                            },

                            "&:first-child": {
                                display: 'none'
                            },

                            "& .MuiTouchRipple-root": {
                                display: 'none'
                            }
                        },
                        "& .Mui-selected": {
                            background: "#fff !important"
                        },

                        "& .MuiList-root": {
                            padding: "12px 3px",
                            // minWidth: "140px"
                        }
                    }
                }
            }}
            {...rest}
        >
            {children}
        </Select>
    );
}

export default CustomSelectTwo